<div class="input-group">
    <div class="input-group-btn">
        @if (hasEditSnapshotsPermissions()) {
            <button
                type="button"
                class="btn btn-default nlr-icon-btn"
                id="snapshotToolBtn"
                [title]="getSnapshotTooltip()"
                [disabled]="isEditSnapshotsDisabled()"
                (click)="createSnapshot()">
                <i
                    class="nlrp-icon nlrp-icon-create-snapshot"
                    [ngClass]="{'max-snapshot-count': hasMaxSnapshotCount()}"></i>
            </button>
        }
    </div>
    @if (hasViewSnapshotsPermissions()) {
        <div>
            <ng-select
                class="nlr-ng-select nlr-ng-select-ribbon nlr-ng-select-button"
                [searchable]="false"
                [clearable]="false"
                id="restoreSnapshotSelect"
                [disabled]="isViewSnapshotsDisabled()"
                [items]="snapshotIds"
                [ngModel]="selectedSnapshotId"
                (open)="refreshSnapshotIds()"
                (change)="restoreSnapshot($event)"
                #restoreSnapshotSelect>
                <ng-template
                    ng-option-tmp
                    let-snapshotId="item">
                    <div class="input-group">
                        <div
                            class="text-nowrap"
                            title="Restore snapshot"
                            (click)="restoreSnapshot(snapshotId)"
                            >{{snapshotId}}</div
                        >
                        <span class="input-group-btn">
                            @if (hasEditSnapshotsPermissions()) {
                                <button
                                    type="button"
                                    class="btn btn-default nlr-icon-btn"
                                    id="clearSnapshotBtn"
                                    title="Clear snapshot"
                                    [disabled]="isEditSnapshotsDisabled()"
                                    (click)="clearSnapshot(snapshotId, $event, restoreSnapshotSelect)">
                                    <i class="nlrp-icon nlrp-icon-trash"></i>
                                </button>
                            }
                        </span>
                    </div>
                </ng-template>
                <ng-template ng-footer-tmp>
                    @if (hasMaxSnapshotCount()) {
                        <div class="max-snapshot-count">
                            0 snapshots remaining<br />
                            The oldest snapshot will be deleted as new ones are created
                        </div>
                    }
                    @if (!hasMaxSnapshotCount()) {
                        <div>
                            {{getRemainingSnapshotCount() + ' Snapshots remaining'}}
                        </div>
                    }
                    @if (hasEditSnapshotsPermissions()) {
                        <button
                            type="button"
                            id="deleteAllBtn"
                            class="btn btn-default btn-xs"
                            [disabled]="isEditSnapshotsDisabled()"
                            (click)="clearAllSnapshots(restoreSnapshotSelect)">
                            Delete All
                        </button>
                    }
                </ng-template>
            </ng-select>
        </div>
    }
</div>
<div class="placeholder"></div>
